import { BsBellFill, BsTriangleFill } from "react-icons/bs";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { getCapital, getLocalUser } from "../functions/utilities";
import styles from "./Header.module.scss";
import NotificationBox from "./NotificationBox/NotificationBox";
import { ReactNode, useEffect, useMemo, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/reduxHooks";
import { useLocation, useNavigate } from "react-router";
import { logout } from "../functions/utilities";
import { MdLogout } from "react-icons/md";
import MeritoDarkLogo from "../../assets/images/MeritoDarkLogo.webp";
// import useAnalyticsEventTracker from "../Hooks/useAnalyticsEventTracker";
import wsProgress, {
  fetchWorkspaceProgressData,
} from "../../redux/wsProgress/wsProgress";
import wsProgressImage from "./../../resources/images/wsProgress.svg";
import { resetNotification } from "../../redux/notifications/notificationSlice";
import InviteIcon from "../../assets/images/InviteIcon.svg";
import InviteClientModal from "./InviteClient/InviteClient";
import { fetchCurrentConnections } from "../../redux/connections/connSlice";
import { LuHourglass } from "react-icons/lu";
import { RestS } from "../../rest/rest-service";
import { changeDfStatus } from "../../redux/dataFetchingProgress/dataFetchingProgress";
import Select from "react-select";
import CustomSelectOptions from "../../pages/Dashboard/Components/trackerModal/CustomSelectOptions";
import ReportSearchBar, {
  SearchBarType,
} from "../../pages/ReportDetails/Components/ReportHeader/reportSearch/ReportSearchBar";
import { DashboardDataPieces, LoadingProgressType, UserRole } from "../../interfaces/interfaces";
import { setRedirectUrl } from "../../redux/temporaryWorkspase/temporaryWorkspace";
import MeritoButton from "../common/MeritoButtons/MeritoButtons";
import { RiUserSharedLine as UserIcon } from 'react-icons/ri'
import { TabRole } from "../../pages/UserManagement/UserManagement";
import { resetAgencyConfig } from "../../redux/agencyConfig/agencyConfig";
import { resetUser, track } from "../../config/amplitude";
// import { HourGlassLoading } from "../common/HourGlassLoading/HourGlassLoading";

type Props = {
  workspaceStore?: boolean;
  children: JSX.Element;
  rightHeaderContent?: JSX.Element;
};

function Header({ workspaceStore = false, children, rightHeaderContent }: Props) {
  let user = getLocalUser();
  // const { toggle, visible } = useModal(false);
  const [notificationPopUpVisible, setNotificationPopUpVisible] =
    useState(false);
  const navigate = useNavigate();
  const {
    all: { unreadCount: allUnreadCount },
    general: { unreadCount: generalUnreadCount },
    collaboration: { unreadCount: collaborationUnreadCount },
    analytics: { unreadCount: analyticsUnreadCount },
  } = useAppSelector((state) => state.notificationState);
  const { isTemporary, isConsolidated } = useAppSelector(
    (state) => state.temporaryWorkspace,
  );

  const combinedCount =
    generalUnreadCount + collaborationUnreadCount + analyticsUnreadCount;
  const notificationParentRef = useRef<HTMLDivElement>(null);
  const [userDropdown, setUserDropDown] = useState(false);
  const navigator = useNavigate();
  const dispatch = useAppDispatch();
  // const gaEventTrackerAS = useAnalyticsEventTracker('Accessibility');
  // const { status } = useAppSelector((state) => state.wsProgress);
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const datapieces: DashboardDataPieces = useAppSelector(
    (state) => state.dashboardDatapieces,
  );
  const [dfProgressCopy, setDfProgressCopy] = useState('Data fetching in progress')
  const [dfCopyVisible, setDfCopyIsVisible] = useState(true)
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const [validatingRPA, setValidatingRPA] = useState(false);
  const { dfProgress, companiesForAgency, dfProgressType, extraConfig } = useAppSelector((state) => {
    return {
      dfProgress: state.dataFetchingProgress?.dfProgress,
      dfProgressType: state.dataFetchingProgress?.loadingType,
      companiesForAgency: state.decisionHub?.companiesForAgency,
      extraConfig: state.dataFetchingProgress?.extraConfig,
    };
  });
  const { pathname } = useLocation();
  const isGstReconciliationPage = pathname.toLowerCase().includes("supplier-intelligence");

  useEffect(() => {
    const validatingRPAExpiry = localStorage.getItem('validatingRPAExpiry')
    // console.log('hola', Number(validatingRPAExpiry), (new Date().getTime()), Number(validatingRPAExpiry) > (new Date().getTime()))
    if (validatingRPAExpiry != null && Number(validatingRPAExpiry) > (new Date().getTime())) {
      setValidatingRPA(true)
    } else {
      setValidatingRPA(false)
    }
  }, [localStorage.getItem('validatingRPAExpiry')])

  const renderName = () => {
    if (!user) {
      navigate("/");
    } else {
      let userNameSplit = user.name.split(" ");
      if (userNameSplit.length > 1) {
        return `${userNameSplit[0].charAt(0)}${userNameSplit[1].charAt(
          0,
        )}`.toUpperCase();
      } else {
        return `${userNameSplit[0].charAt(0)}${userNameSplit[0].charAt(
          1,
        )}`.toUpperCase();
      }
    }
  };

  const getDataFetchingProgressStatus = async () => {
    try {
      const data = await RestS.getDataFetchingStatus();
      dispatch(changeDfStatus(data));
    } catch (error) {
      console.log(error);
      dispatch(changeDfStatus({ status: 0, type: null, extraConfig: null }));
    }
  };

  useEffect(() => {
    dispatch(fetchWorkspaceProgressData());
    dispatch(fetchCurrentConnections({}));
    getDataFetchingProgressStatus();
    return () => {
      dispatch(resetNotification());
    };
  }, []);

  const searchBarType = useMemo(() => {
    if ((pathname as string) === "/DecisionHub")
      return SearchBarType.decisionHub;
    if ((pathname as string) === "/") return SearchBarType.dashboard;
    return SearchBarType.workspace;
  }, [pathname]);

  const showReportSearchBar = useMemo(() => {
    if (searchBarType === SearchBarType.decisionHub) return true;
    console.log('datapieces', datapieces)
    return Object.keys(datapieces).reduce(
      (previous: boolean, current: string) => {
        // console.log('current', current);
        const value: Array<any> = datapieces[current];
        return current.includes("pinned")
          ? value?.length > 0 || previous
          : false;
      },
      false,
    );
  }, [datapieces, searchBarType]);

  // console.log('showReportSearchBar', showReportSearchBar)

  const checkForShopifyUpdate = useMemo(() => {
    const shopifyUpdateTypes = new Set([LoadingProgressType.fetchingProductCostDf, LoadingProgressType.fetchingProductCostFs, LoadingProgressType.fetcingProductCostIg]);
    if (shopifyUpdateTypes.has(dfProgressType) && extraConfig && extraConfig['fetchOnlyProductCost'] && extraConfig['fetchOnlyFinance']) return true;
    return false;
  }, [dfProgress, dfProgressType])

  const applyInterval = useMemo(() => {
    return (dfProgressCopy === 'Data fetching in progress' ||
      dfProgressCopy === "This will be completed shortly") &&
      dfProgressType != LoadingProgressType.dataFetchingPrd &&
      dfProgressType != LoadingProgressType.deleteDataFs &&
      dfProgressType != LoadingProgressType.deleteDataInsight &&
      checkForShopifyUpdate
  }, [])

  useEffect(() => {
    if (applyInterval) {
      const dfProgressInterval = setInterval(() => {
        setDfCopyIsVisible(false); // Trigger fade-out
        setTimeout(() => {
          setDfProgressCopy(prevStatus => {
            const newStatus = prevStatus === 'Data fetching in progress' ? 'This will be completed shortly' : 'Data fetching in progress';
            return newStatus;
          });
          setDfCopyIsVisible(true); // Trigger fade-in
        }, 200); // Match this to the duration of the fade-out animation
      }, 3000);
      // Cleanup function to clear the interval when the component unmounts
      return () => clearInterval(dfProgressInterval);
    }
  }, []);


  return (
    <>
      <div id="indexHeader" className={styles.header}>
        <div className={styles.leftSideContent}>
          <div
            className={styles.brandLogo}
            onClick={() => {
              if (
                pathname.toLowerCase().includes("reportdetails") &&
                (isTemporary || !isConsolidated)
              ) {
                dispatch(setRedirectUrl("/"));
              } else navigator("/");
            }}
            style={{ cursor: "pointer" }}
          >
            <img
              style={{ maxWidth: "88%" }}
              src={MeritoDarkLogo}
              alt="brnadlogo"
              className="img-fluid"
              height={"100%"}
              width={"100%"}
            />
          </div>
          {children ? (
            <>
              <hr className={styles.divider}></hr>
              {children}
            </>
          ) : null}
        </div>

        {/* <div className={styles.headerTitle}>{getCapital(user.name)}'s Data Hub</div> */}
        {/* <div className={styles.searchBox} style={{ pointerEvents: 'none' }}>
          <Input className={`border-0 border-bottom `} placeholder="Search" />
          <span className={styles.searchIcon}>
            <img
              src={Lock}
              alt="Lock"
            />
            <span className={styles.hoverSpan}>Coming Soon: Search across all reports on Jigsaw</span>
            <Search />
          </span>
        </div>
        <div className={styles.notificationIcon} ref={notificationParentRef}>
        </div> */}
        {/* <div>
        
        </div> */}
        <div className={styles.rightSideCont}>
          {/* <div className={styles.inviteBtnContainer}> */}
          {user?.role === UserRole.Agency && (
            <>
              {["/", "/DecisionHub"].includes(pathname as string) &&
                showReportSearchBar && (
                  <ReportSearchBar
                    type={searchBarType}
                    data={
                      searchBarType === SearchBarType.decisionHub
                        ? companiesForAgency
                        : datapieces
                    }
                    setSelected={setSelectedCustomer}
                  />
                )}
              {location.pathname.toLowerCase().includes('settings') || isGstReconciliationPage || user?.role != UserRole.Agency ? null : <MeritoButton
                type="primary-1"
                icon={<UserIcon />}
                btnText="Invite Brand"
                onClick={() => {
                  navigate(`/settings?tab=${TabRole.Brand}&popup=true`);
                }}
              />}
            </>
          )}
          {rightHeaderContent ?? null}
          {(dfProgress || validatingRPA) && !pathname.toLowerCase().includes('supplier-intelligence') ? (
            <div className={styles.wsProgressCont}>
              {!pathname.toLowerCase().includes("reportdetails") ? (
                <>
                  {checkForShopifyUpdate ?
                    <div className={`${styles.dataFetchText} ${styles.rightAlign}`}>
                      Updating App
                    </div>
                    : dfProgressType == LoadingProgressType.dataFetchingPrd ?
                      <div className={styles.dataFetchText}>
                        <p className={`${styles.statusText} ${dfCopyVisible ? styles.fadeIn : styles.fadeOut}`}>
                          Pulling Latest Costs From Shopify
                        </p>
                      </div>
                      : dfProgressType == LoadingProgressType.insightGeneration ?
                        <div className={styles.dataFetchText}>
                          {pathname.toLowerCase().includes("pnltracker") ?
                            <p className={`${styles.statusText} ${dfCopyVisible ? styles.fadeIn : styles.fadeOut}`}>
                              {dfProgressCopy}
                            </p>
                            : 'Generating Growth Ideas'}
                        </div>
                        : dfProgressType == LoadingProgressType.deleteDataFs || dfProgressType == LoadingProgressType.deleteDataInsight ?
                          <div className={`${styles.dataFetchText} ${styles.rightAlign}`}>
                            Deleting Data
                          </div>
                          : validatingRPA ?
                            <div className={styles.dataFetchText}>
                              <p className={`${styles.statusText} ${validatingRPA ? styles.fadeIn : styles.fadeOut}`}>
                                Validating Credentials
                              </p>
                            </div> :
                            <div className={styles.dataFetchText}>
                              <p className={`${styles.statusText} ${dfCopyVisible ? styles.fadeIn : styles.fadeOut}`}>
                                {dfProgressCopy}
                              </p>
                            </div>}
                </>
              ) : null}
              {/* <HourGlassLoading /> */}
              {/* <img className={styles.animate} src={wsProgressImage} /> */}
              <div className={styles.circle}>
                <div className={styles.icon}>
                  <LuHourglass />
                </div>
              </div>
            </div>
          ) : null}
          <div className={styles.profileBlock}>
            <Dropdown
              isOpen={userDropdown}
              toggle={() => setUserDropDown((prev) => !prev)}
            >
              <DropdownToggle className={styles.dropToggle}>
                <div
                  className={`${styles.profileImage}`}
                  style={{ cursor: "pointer" }}
                >
                  {renderName()}
                </div>
              </DropdownToggle>
              <DropdownMenu className={styles.profileDropDown}>
                <div
                  className={`${styles.navLink}  `}
                  onClick={() => {
                    // gaEventTrackerAS("Logout");
                    track("user_logged_out", {
                      role: user?.role,
                      company_id: user?.companyId,
                    });
                    resetUser();
                    let response = logout();
                    dispatch(resetAgencyConfig());
                    if (response) navigator("/login");
                  }}
                >
                  <span className={styles.navIcon}>
                    <MdLogout />
                  </span>
                  <span className={`${styles.navLable}`}>Logout</span>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
